/**
 * The compliance workspace's search box state.
 *
 * The box lives in the workspace header (one per space), but what a query
 * *means* belongs to the section under it — a policy name on Policies, a
 * connector name on Integrations. This context is the seam between the two:
 * the layout owns the value, sections read it.
 *
 * @module components/regulation/regulationSearch
 */
import { createContext, useContext } from "react";

const RegulationSearchContext = createContext<string>("");

export const RegulationSearchProvider = RegulationSearchContext.Provider;

/** The header's current query. Empty string when nothing is being searched. */
export function useRegulationSearch(): string {
  return useContext(RegulationSearchContext);
}
